import React, { useState } from 'react';
import './App.css';
import PredefinedGames from './PredefinedGames';
import GameVariables from './GameVariables';
import AvailableTokens from './AvailableTokens';
import GameContainers from './GameContainers';
import GameSolution from './GameSolution';
//import ArrowRight from './ArrowRight';
import {GameDefinition, Move} from './types';
import SERVER from './serverUrl';


function App() {

  const [gameContainerCount, setGameContainerCount] = useState(14);
  const [gameColorCount, setGameColorCount] = useState(12);
  const [fillState, setFillState] = useState<string[]>([]);
  const [readyToSolve, setReadyToSolve] = useState(false);
  const [gameStateChanged, setGameStateChanged] = useState(true);
  const [gameName, setGameName] = useState("");
  const [gameToSolve, setGameToSolve] = useState<GameDefinition | undefined>(undefined);
  const [solution, setSolution] = useState<Array<Move> | null>([])

  const presetGameSelected : React.MouseEventHandler<HTMLDivElement> = (e) => {
    var gameState = e.currentTarget.getAttribute("data-gamestate");

    if (gameState == null) {return;}
    
    var containers = gameState.split("/").slice(0,-1);
    console.log(`containers length: ${containers.length}`);
    setGameContainerCount(containers.length);
    //reverse gameState from top-down to fillState that is bottom-up
    containers = containers.map((value) => value.split(",").reverse().join(","));
    setFillState(containers.join(",").split(","));
    setGameStateChanged(true);
    setReadyToSolve(true)
  }
  
  const placeToken: React.MouseEventHandler<HTMLDivElement> = (e) => {
    var color = e.currentTarget.getAttribute("color");
    if (color == null) { return }
    
    var countOfColorUsed = fillState.filter((value) => value === color).length;
    if (countOfColorUsed >= 4) {return}

    var currentState = fillState.map((value) => value); //copy the array, calling setFillState(fillState) doesn't refresh....
    currentState.push(color);
    setFillState(currentState);
    setGameStateChanged(true);

    setReadyToSolve(currentState.length === ((gameContainerCount - 2) * 4))
  }

  const undoToken: React.MouseEventHandler<HTMLDivElement> = (e) => {
    var currentState = fillState.filter((value) => value.length > 0);
    currentState.pop();
    setFillState(currentState);
    setGameStateChanged(true);
    setReadyToSolve(false);
  }

  const handleSolve = () => {
    setReadyToSolve(false);
    //convert fillState "bottom-up" to game-state "top-down" containers
    var fullData = fillState.map((value) => value);
    fullData.length = gameContainerCount * 4;
    fullData.fill("", fillState.length, gameContainerCount * 4);

    var idx = 0;
    var idx2 = 0;
    var gameState = "";
    for(idx = 0; idx < gameContainerCount; idx++){
      for (idx2 = 3; idx2 >= 0; idx2--) {
        gameState += fullData[(idx * 4) + idx2];
        if (idx2 === 0) {
          gameState += "/"
        } else {
          gameState += ","
        }
      }
    }

    var gameToSolve = {
      name: gameName,
      initialState: gameState
    }
    
    console.log(`GameToSolve: ${JSON.stringify(gameToSolve)}`);
    setGameStateChanged(false);
    setGameToSolve(gameToSolve);

    setSolution(null);

    fetch(`${SERVER}/solveGame`, {
         method: 'POST',
         body: JSON.stringify(gameToSolve)
     }
    )
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw response;
            }
        })
        .then(data=> {
            setSolution(data);
            gameSolved();
        })
        .catch(error => {
            console.error("Error fetching data: ", error);
        })
        .finally(() => {
        })

  }

  const gameSolved = () => {
  }

  // const debugAlert = () => {
  //   alert('debug')
  // }
  

  return (
    <div className="App">
      <header>
          <h1>Welcome to Ball Sort Solver!</h1>
      </header>
      <div id="instructions">
        <p>Read more about this personal project on <a href="https://watersjn.wixsite.com/jeffh2o/post/ball-sort-solver">my blog</a>.</p>
        <p>This app can be used to help you <i>solve</i> a ball sort game.  It does not let you <i>play</i> the game (yet!).</p>
        <p>Select a predefined game, or, populate the containers by selecting the balls in order to fill up the containers to match your game, then press Solve</p>
      </div>
      <div className="main">
        <div className="predefinedGamesColumn">
          <PredefinedGames handleClick={presetGameSelected} />
        </div>
        <div className="game">
          <GameVariables containerCount={gameContainerCount} colorCount={gameColorCount} gameName={gameName} onGameContainerCountChange={setGameContainerCount} onGameColorCountChange={setGameColorCount} onGameNameChange={setGameName} />
          <div className="gameSetup" >
            <div className="availableTokens">
              <AvailableTokens gameContainerCount={gameContainerCount} handleClick={placeToken} usedTokens={fillState}/>
            </div>
            <div className="gameMoveInstructions">Tap an available token to move it to the next available spot in the game board.</div>
            <div className="columnGameBoard">
              <GameContainers count={gameContainerCount} fillState={fillState} handleClick={undoToken}/>
              <div onClick={undoToken}><button>Undo</button></div>
            </div>
          </div>
          <button disabled={!readyToSolve} onClick={handleSolve}>Solve!</button>
          <GameSolution solution={solution} gameStateChanged={gameStateChanged} gameSolved={gameSolved}/>
        </div>
      </div>
    </div>
  );
}

export default App;
